module.exports = __webpack_public_path__ + "img/pc_p3_y2.2f55a543.png";